import assitanceIcon from "../../../styles/img/newPackEntrepreneur/assitance.svg";
import contratsIcon from "../../../styles/img/newPackEntrepreneur/contrats.svg";
import templateIcon from "../../../styles/img/newPackEntrepreneur/template.svg";

export const packEntrepreneurData = {
  181:{
    header:{
      packTitle: "Pack entrepreneur",
      packsubTitle: "Ce pack contient l'ensemble des éléments utiles aux entrepreneurs afin qu'ils puissent correctement exercer leur activité.",
    },
    content:[
      {
        picture: assitanceIcon,
        optionTitle:"Assistance Entrepreneur",
        optionText:"Bénéficiez d'un accès privilégié à notre expertise pour répondre à toutes vos inquiétudes"
      },
      {
        picture: contratsIcon,
        optionTitle:"Contrats personnalisés",
        optionText:"Pendant 2 mois, vous avez un accès illimité à notre générateur de contrats personnalisés."
      },
      {
        picture: templateIcon,
        optionTitle:"Modèles de devis et factures",
        optionText:"Nous vous fournissons des templates de devis et de factures pré-remplis et aux normes."
      },
    ],
    footer:{
      oldPrice:49,
      newPrice:32,
      btnText:"Ajouter",
      skipBtnText:"Ignorer et passer au paiement",
      footerText:"Vous pouvez prendre ce pack plus tard mais le tarif réduit de 32€ ne sera plus applicable. Le Pack Entrepreneur est valable 2 mois à partir de la date d'achat."
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/buy/upsell/pack-entrepreneurAB-Data.js